<template>
    <div class="col-12 col-lg-8">
        <div class="row">
            <block-headline :icon="activeTab.icon"
                            :text="activeTab.text" class="col-12 col-md-6 mb-3"></block-headline>

            <div class="col-12">
                <regional-goods v-if="activeTab.value === 'regionalGoods'"></regional-goods>

                <offers v-if="activeTab.value === 'offers'"></offers>

                <regional-services v-if="activeTab.value === 'regionalServices'"></regional-services>

                <national-services v-if="activeTab.value === 'nationalServices'"></national-services>

                <brands v-if="activeTab.value === 'brands'"></brands>

                <leaflets v-if="activeTab.value === 'leaflets'"></leaflets>

                <vouchers v-if="activeTab.value === 'vouchers'"></vouchers>

                <about v-if="activeTab.value === 'about'"></about>

                <galleries v-if="activeTab.value === 'gallery'"></galleries>

                <jobs v-if="activeTab.value === 'jobs'"></jobs>
            </div>
        </div>
    </div>
</template>

<script>
import RegionalGoods from '../RegionalGoods/RegionalGoods';
import Offers from '../Offers/Offers';
import RegionalServices from '../RegionalServices/RegionalServices';
import NationalServices from '../NationalServices/NationalServices';
import Brands from '../Brands/Brands';
import Leaflets from '../Leaflets/Leaflets';
import Vouchers from '../Vouchers/Vouchers';
import About from '../About/About';
import Galleries from '../Galleries/Galleries';
import Jobs from '../Jobs/Jobs';

export default {
    name: 'MarketContent',
    components: {
        Jobs, Galleries, About, Vouchers, Leaflets, NationalServices, RegionalServices, Offers, RegionalGoods, Brands,
    },
    props: {
        activeTab: null,
    },
    data() {
        return {
            isNew: false,
        };
    },
};
</script>
